import React, {forwardRef, isValidElement, cloneElement, createElement} from "react";
import {withStyles, FormControl, FormLabel, styled, Box} from "@material-ui/core";

const BasicFormControl = withStyles((theme) => ({
    root: {
        '& fieldset': {
            top: '-5px !important',
            left: '0 !important',
            right: '0 !important',
            bottom: '0 !important',
            margin: '0 !important',
            padding: '0 8px !important',
            overflow: 'hidden !important',
            position: 'absolute !important',
            borderColor: '#ced4da !important',
            borderStyle: 'solid !important',
            borderWidth: '1px !important',
            borderRadius: '4px !important',
            pointerEvents: 'none !important'
        },
        '& legend': {
            width: 'auto !important',
            height: '11px !important',
            display: 'block !important',
            padding: '0 !important',
            fontSize: '14px !important',
            maxWidth: '1000px !important',
            textAlign: 'left !important',
            visibility: 'hidden !important',
            '& span': {
                display: 'inline-block !important',
                paddingLeft: '5px !important',
                paddingRight: '5px !important'
            }
        }
    }
}))(FormControl);

const BasicFormLabel = withStyles((theme) => ({
    root: {
        display: 'block !important',
        position: 'absolute !important',
        top: '0px !important',
        left: '0px !important',
        zIndex: '1 !important',
        fontFamily: 'var(--poppins)',
        transform: 'translate(16px, -8px)!important',
        transformOrigin: 'top left !important',
        color: '#77557dcf !important',
        fontSize: '13px !important',
        fontWeight: '500 !important',
        marginBottom: '4px !important',
        height: 'unset !important',
    }
}))(FormLabel);

const SxBox = styled(Box)({});

const BasicFormControlWithLabelV2 = forwardRef(({ label, fullWidth, component, sx, ...props}, ref) => {

    if (!component) return null;

    const content = isValidElement(component)
        ? cloneElement(component, { ref, fullWidth, ...props })
        : createElement(component, { ref, fullWidth, ...props });

    return (
        <BasicFormControl fullWidth={fullWidth}>
            <SxBox sx={sx}>
                {label && <BasicFormLabel>{label}</BasicFormLabel>}
                {content}
                {
                    label &&
                    <fieldset>
                        <legend>
                        <span>
                            {label}
                        </span>
                        </legend>
                    </fieldset>
                }
            </SxBox>
        </BasicFormControl>
    );
});

export default BasicFormControlWithLabelV2;